
import { ServiceCategory } from "../models/BdaService";
import client from "./axios";

const categoriesUrl = `${window.__env.KRAKEND_URL}/v1/services/categories`;

export const Categories = {
  getCategories: (params?: URLSearchParams) => client.get<ServiceCategory[]>(categoriesUrl, { params }),
  getCategory: (id: number) => client.get<ServiceCategory>(`${categoriesUrl}/${id}`),
  createCategory: (body: ServiceCategory) => client.post(categoriesUrl, body),
  updateCategory: (id: number, body: ServiceCategory) => client.put(`${categoriesUrl}/${id}`, body),
  deleteCategory: (id: number) => client.delete(`${categoriesUrl}/${id}`),
}